module.exports = __webpack_public_path__ + "img/banner-right-btn.cfa6d553.svg";